<template>
	<div id="pembayaran-detail">
    <!-- begin breadcrumb -->
		<ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>Pembayaran</li>
      <li>
        <router-link :to="{path: '/pembayaran'}">List Pembayaran User</router-link>
      </li>
      <li class="active">Detail Pembayaran</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Detail Pembayaran</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="pull-right" v-if="data.status === status.CONFIRMED">
							<button type="button" class="btn btn-success btn-xs dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								Action <span class="caret"></span>
							</button>
							<ul class="dropdown-menu">
								<li v-for="(value, key) in this.statusAction" :key="key">
                  <a @click="updatePembayaranStatus(key)">{{ value }}</a>
                </li>
							</ul>
            </div>
            <div class="pull-right" v-if="data.status === status.EXPIRED">
							<button type="button" class="btn btn-danger btn-xs" @click="updatePembayaranStatus('CONFIRMED')"> Reset </button>
            </div>
            <h4 class="panel-title">Order ID : {{ data.code }}</h4>
          </div>
          <div class="panel-body">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" :key="key">{{message}}</li>
              </ul>
            </div>
            <!-- begin form -->
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group">
                  <label class="col-md-2 control-label">Nama</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.user_name" readonly>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-2 control-label">Email</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.user_email" readonly>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-2 control-label">Nomor Telepon</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.phone_number" readonly>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-2 control-label">Nama Produk</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.title" readonly>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-2 control-label">Tipe Produk</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.type" readonly>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-2 control-label">Dari Rekening</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.bank_name" readonly>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-2 control-label">Ke Rekening</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.payment_bank_name" readonly>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-2 control-label">Total Bayar</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.unique_price" readonly>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-2 control-label">Tanggal Transfer</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.transfer_datetime" readonly>
                  </div>
                </div>

                <div class="form-group" v-if="data.status !== status.CHECKOUT && data.status !== status.EXPIRED">
                  <label class="col-md-2 control-label">Bukti Transfer</label>
                  <div class="col-md-6 col-xs-12">
                    <viewer :images="[data.receipt_img]" :options="{navbar: false}">
                      <img class="img-fluid" :src="data.receipt_img" />
                    </viewer>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-2 control-label">Status</label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.status" readonly>
                  </div>
                </div>
              </div>
            </form>
            <!-- end form -->
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
	</div>
</template>

<style>
.img-fluid{
  cursor:pointer;
}
</style>
<script>
import SalesService from '@/services/sales.js'
import Spinner from '@/components/plugins/Spinner'
import moment from 'moment'

export default {
  name: 'pembayaran-detail',
  components: {
    'app-spinner': Spinner,
  },
  data: function () {
    return {
      queryId: null,
      errors: [],
      isLoading: false,
      status: {
        CHECKOUT: 'CHECKOUT',
        CONFIRMED: 'CONFIRMED',
        EXPIRED: 'EXPIRED',
        REJECTED: 'REJECTED',
        ACTIVATED: 'ACTIVATED',
        REFUND: 'REFUND',
      },
      statusAction: {
        REJECTED: 'Reject',
        ACTIVATED: 'Activate',
        REFUND: 'Refund',
      },
      data: {
        code: null,
        user_name: null,
        title: null,
        type: null,
        phone_number: null,
        user_email: null,
        bank_name: null,
        payment_bank_name: null,
        transfer_datetime: null,
        receipt_img: null,
        status: null,
        unique_price: null
      }
    }
  },
  mounted: function () {
    this.queryId = this.$route.query.id
    this.fetchData()
  },
  methods: {
    fetchData: function () {
      var id = this.queryId
      var context = this

      this.isLoading = true

      SalesService.getPembayaranDetail(id, function (result) {
        context.isLoading = false

        if (result.success) {
          context.data.code = result.data.code
          context.data.user_name = result.data.user_name
          context.data.user_email = result.data.user_email
          context.data.title = result.data.title
          context.data.type = result.data.type
          context.data.phone_number = result.data.phone_number
          context.data.bank_name = result.data.bank_name
          context.data.payment_bank_name = result.data.payment_bank_name
          context.data.transfer_datetime = moment(result.data.transfer_datetime).format("dddd, DD-MM-YYYY hh:mm:ss")
          context.data.receipt_img = result.data.receipt_img
          context.data.status = result.data.status
          context.data.unique_price = context.convertToRupiah(result.data.unique_price)
        } else {
          alert('Terjadi kesalahan : ' + result.message)
        }
      })
    },
    convertToRupiah: function (value) {
			var rupiah = ''
			var angkarev = value.toString().split('').reverse().join('')
			for (var i = 0; i < angkarev.length; i++) if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + '.'
			return 'Rp ' + rupiah.split('', rupiah.length - 1).reverse().join('')
		},
    updatePembayaranStatus: function (status) {
      var context = this
      var id = this.queryId
      var confirmed = window.confirm("Apakah anda yakin akan mengubah status ini menjadi " + status + " ?")

      if (confirmed) {
        this.isLoading = true

        SalesService.updatePembayaranStatus(id, status, function (result) {
          if (result.success) context.$router.push('/pembayaran')
          else {
            context.isLoading = false
            alert('Terjadi kesalahan : ' + result.message)
          }
        })
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// PembayaranDetail.vue?4e8c1ea8